import script from "./QualificationBlockedDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./QualificationBlockedDialog.vue?vue&type=script&setup=true&lang=ts"

import "./qualificationDialog.css?vue&type=style&index=0&id=5140352b&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5140352b"]])

export default __exports__